var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNeutral(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "-3 -3 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13,25.8c7.1,0,12.8-5.7,12.8-12.8S20.1.2,13,.2.2,5.9.2,13s5.7,12.8,12.8,12.8Z",
    fill: "#BDBCBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2,6.4c0-.5-.6-.8-1.5-.8s-2.6.4-3.8,2c-.2.3,0,.4.3.3.8-.6,2.8-1.5,4.4-1.3.6,0,.6-.2.6-.2Z",
    fill: "#6D6D6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8,12.6c.7,0,1.2-.8,1.2-1.9s-.6-1.9-1.2-1.9-1.2.8-1.2,1.9.6,1.9,1.2,1.9Z",
    fill: "#6D6D6C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8,9.5c.5,0,1,.5,1.2,1.1,0-1-.6-1.8-1.2-1.8s-1.2.8-1.2,1.8c.2-.7.7-1.1,1.2-1.1Z",
    fill: "#616160"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8,6.4c0-.5.6-.8,1.5-.8s2.6.4,3.8,2c.2.3-.1.4-.3.3-.8-.6-2.8-1.5-4.4-1.3-.6,0-.6-.2-.6-.2Z",
    fill: "#6D6D6C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2,12.6c.7,0,1.2-.8,1.2-1.9s-.6-1.9-1.2-1.9-1.2.8-1.2,1.9.6,1.9,1.2,1.9Z",
    fill: "#6D6D6C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2,9.5c-.5,0-1,.5-1.2,1.1,0-1,.6-1.8,1.2-1.8s1.2.8,1.2,1.8c-.2-.7-.7-1.1-1.2-1.1Z",
    fill: "#616160"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 18.1,
    width: 6.3,
    height: 1.1,
    rx: 0.6,
    ry: 0.6,
    fill: "#616160"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutral);
export default __webpack_public_path__ + "static/media/neutral.5fef0c6a416304e5adb5344f595d80ff.svg";
export { ForwardRef as ReactComponent };